
import React from 'react'
import { Link} from 'gatsby'
import {DateDisplay} from '@utils/DateDisplay'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import SubjectBadge from '@components/SubjectBadge'
import '../../node_modules/@syncfusion/ej2-base/styles/material.css'
import '../../node_modules/@syncfusion/ej2-inputs/styles/material.css'
import '../../node_modules/@syncfusion/ej2-navigations/styles/material.css'
import '../../node_modules/@syncfusion/ej2-react-grids/styles/material.css'
import '../styles/material.css'
import '../styles/MaterialOverrides.css'

import {  ColumnDirective, ColumnsDirective, GridComponent, Page, Sort, Inject, Search, Toolbar, DetailRow  } from '@syncfusion/ej2-react-grids';

const ContentGrid = ({documents}) => {
    if(!documents) return null;
    //add flattened string of subjects to object so users can search by subject (use as a hidden field)
    //also add the url in the data object so it's accessible to title template
    documents.forEach(doc => {
        doc.data.subjects_string = doc.data.body[0].items.map((item) => {
            if (item.subject.type !== "broken_type") {
                return item.subject.document.data.subject_name
            }
        }).join('| ');
        doc.data.url = doc.url;
    })

    const toolBarOptions = ['Search'];

    const detailTemplate = ({data}) => {
        let sourceRendered;
        let resourceTypeRendered;
        let contentCategoryRendered;
        let documentDesignationRendered;
        if(data.source != null && data.source.length > 0){
            sourceRendered = <p><span className="font-weight-bold">Source: </span>{data.source}</p>
        }
        if(data.resource_type != null && data.resource_type.length > 0){
            resourceTypeRendered = <p><span className="font-weight-bold">Resource Type: </span>{data.resource_type}</p>
        }
        if(data.content_category != null && data.content_category.length > 0){
            contentCategoryRendered = <p><span className="font-weight-bold">Content Type: </span>{data.content_category}</p>
        }
        if(data.document_designation != null && data.document_designation.length > 0){
            documentDesignationRendered = <p><span className="font-weight-bold">Document Number: </span>{data.document_designation}</p>
        }
        return (
            <Row className="detailtable">
                <Col>{sourceRendered}</Col>
                <Col>{resourceTypeRendered}</Col>
                <Col>{contentCategoryRendered}{documentDesignationRendered}</Col> 
            </Row>
        )
    }

    const titleTemplate = ({data}) => {
        return (
            <Link className="animated" to={ data.url}>
                 { data.title }
            </Link>      
        )
    }

    const subjectTemplate = ({data}) => {
        return data.body[0].items.map((item) => {
            if(item.subject.type !== "broken_type"){
                return <SubjectBadge subject= {item} key={ item.subject.document.id}/>
            }
            else {
                return null
            }
        })
    }

    function getFormattedDate(field, data, column){
        return DateDisplay(data.data.date_published)
    }

    return (
        <>
        <GridComponent dataSource={documents} detailTemplate={detailTemplate.bind(this)} allowPaging={true} pageSettings={{pageSize: 25}} toolbar={toolBarOptions} allowSorting={true} allowTextWrap={true}>
            <ColumnsDirective>
                <ColumnDirective field='data.title' headerText='Title' template={titleTemplate}  width='500' />
                <ColumnDirective field='data.body' headerText='Subject(s)' width='200' allowSorting={false} template={subjectTemplate}/>
                <ColumnDirective field='data.description' headerText='Description'/>
                <ColumnDirective field='data.date_published' valueAccessor={getFormattedDate} headerText='Published' width='150'/>
                <ColumnDirective field='data.subjects_string' visible={false} width='10'/>
                <ColumnDirective field='data.content_category' visible={false} width='10'/>
                <ColumnDirective field='data.document_designation' visible={false} width='10'/>
                <ColumnDirective field='data.source' visible={false} width='10'/>
            </ColumnsDirective>
            <Inject services={[Page, Sort, Search, Toolbar, DetailRow]} />
        </GridComponent>
        </>
    )
}

export default ContentGrid;